export default function TableDataAddDefaultValue (columnsStr: string, data: any[]): any[] {
    const defaultValueMap: any = {};
    columnsStr.split(',').forEach((v) => {
        defaultValueMap[v] = '-';
    })

    return data.map((v) => {
        for (const key in v) {
            if (!v[key]) {
                v[key] = '-'
            }
        }
        return {
            ...defaultValueMap,
            ...v
        }
    })
}
